import {
  Button,
  CardInteraction,
  Flex,
  ModalTrigger,
} from '@utilitywarehouse/hearth-react';
import { InfoSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import { FC, ReactNode } from 'react';

import './styles.scss';
import { BreakdownButtonConfig } from './types';

interface WrapperProps {
  children: ReactNode;
}

interface TriggerButtonProps {
  onClick?: () => void;
  label?: string;
}

interface BreakdownButtonProps {
  breakdown: BreakdownButtonConfig;
}

const Wrapper: FC<WrapperProps> = ({ children }) => {
  return (
    <CardInteraction secondary>
      <Flex alignItems="start">{children}</Flex>
    </CardInteraction>
  );
};

const TriggerButton = ({ onClick, label }: TriggerButtonProps) => (
  <Button
    variant="ghost"
    size="sm"
    paddingNone
    className="service-tile__breakdown-button"
    onClick={onClick}
    type="button"
  >
    <InfoSmallIcon /> {label}
  </Button>
);

const BreakdownButton = ({ breakdown }: BreakdownButtonProps) => {
  if (!breakdown) {
    return null;
  }

  const { label } = breakdown;

  if (breakdown.variant === 'button') {
    return (
      <Wrapper>
        <TriggerButton onClick={breakdown.onClick} label={label} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ModalTrigger>
        <TriggerButton label={label} />
      </ModalTrigger>
    </Wrapper>
  );
};

export { BreakdownButton };
export type { BreakdownButtonConfig };
